import { render, staticRenderFns } from "./page-aboutus.vue?vue&type=template&id=0fa2a876&"
import script from "./page-aboutus.vue?vue&type=script&lang=js&"
export * from "./page-aboutus.vue?vue&type=script&lang=js&"
import style0 from "./page-aboutus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports